import axios from 'axios';
// import types from './mutations-types';

const actions = {
  async restoreAction({ commit }, obj) {
    await axios.post(
      `${process.env.API_ROOT}/trash/restore-action/${obj.id}`,
      {},
      {
        headers: {
          'x-access-token': obj.token,
        },
      },
    );
  },
  async restoreAnswer({ commit }, obj) {
    await axios.post(
      `${process.env.API_ROOT}/trash/restore-answer/${obj.id}`,
      {},
      {
        headers: {
          'x-access-token': obj.token,
        },
      },
    );
  },
};

export default actions;



// WEBPACK FOOTER //
// ./src/store/modules/trash/actions.js